import axios from 'axios';
import { encryptPayload, normalizeEncryptedApiResponse, plainObjectFromFormData } from './customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from './companySettingsCache';

export async function postGetProductCategories(fullUrl, jwtToken, { draw, start, length, searchValue }) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const payload = {
    draw,
    start,
    length,
    search: { value: searchValue ?? '', regex: 'false' },
  };
  let body;
  if (useEncrypt) {
    const ep = encryptPayload(payload);
    if (!ep) {
      return {};
    }
    const fd = new FormData();
    fd.append('encrypted_payload', ep);
    body = fd;
  } else {
    const fd = new FormData();
    fd.append('draw', String(draw));
    fd.append('start', String(start));
    fd.append('length', String(length));
    fd.append('search[value]', String(payload.search.value));
    fd.append('search[regex]', payload.search.regex);
    body = fd;
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}

function pickCategoryImageFile(formData) {
  if (formData && typeof formData.get === 'function') {
    const fromImage = formData.get('image');
    if (fromImage instanceof File && fromImage.size > 0) return fromImage;
    const fromCategory = formData.get('category_image');
    if (fromCategory instanceof File && fromCategory.size > 0) return fromCategory;
  }
  const ids = ['category_image_input', 'category_image_input_edit'];
  for (let i = 0; i < ids.length; i += 1) {
    const el = typeof document !== 'undefined' ? document.getElementById(ids[i]) : null;
    if (el && el.files && el.files[0]) return el.files[0];
  }
  return null;
}

export async function axiosPostProductCategoriesForm(url, bearerToken, formData) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const imageFile = pickCategoryImageFile(formData);
  let body;
  if (useEncrypt) {
    const plain = plainObjectFromFormData(formData);
    const ep = encryptPayload(plain);
    if (!ep) {
      throw new Error('ENCRYPT_KEY_MISSING');
    }
    body = new FormData();
    body.append('encrypted_payload', ep);
    if (imageFile) {
      body.append('image', imageFile);
      body.append('category_image', imageFile);
    }
  } else {
    body = formData;
    if (imageFile && !body.get('image')) {
      body.append('image', imageFile);
    }
    if (imageFile && !body.get('category_image')) {
      body.append('category_image', imageFile);
    }
  }
  const res = await axios.post(url, body, {
    headers: { authorization: `Bearer ${bearerToken}` },
  });
  return normalizeEncryptedApiResponse(res.data, useEncrypt);
}
